/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown>, field: NonNullable<unknown> }} Warning_Unknown_ValueInputs */

const en_warning_unknown_value = /** @type {(inputs: Warning_Unknown_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nothing called ${i?.value} for ${i?.field}`)
};

const de_warning_unknown_value = /** @type {(inputs: Warning_Unknown_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nichts namens ${i?.value} für ${i?.field}`)
};

/**
* | output |
* | --- |
* | "Nothing called {value} for {field}" |
*
* @param {Warning_Unknown_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warning_unknown_value = /** @type {((inputs: Warning_Unknown_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_Unknown_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_warning_unknown_value(inputs)
	return en_warning_unknown_value(inputs)
});